import Vue from 'vue'
import VueRouter from 'vue-router'
import vueXstore from '@/store/index';

Vue.use(VueRouter)

// let routes = [
// 	{
// 		path: '*',
// 		name: 'page404',
// 		component: () => import('../views/404.vue'),
// 	},
// 	{
// 		path: '/',
// 		name: 'Home',
// 		redirect: '/maintenancesys',
// 		meta: {
// 			requiresAuth: false,
// 		},
// 	},
// 	{
// 		path: '/maintenancesys',
// 		name: 'maintenancesys',
// 		meta: {
// 			layoutClass: 'layout-sign-up',
// 		},
// 		component: () => import('../muic/maintancepage/mainclosemy.vue'),
// 	}
// ]

let routes = [
	{
		path: '*',
		name: 'page404',
		component: () => import('../views/404.vue'),
	},
	{
		path: '/',
		name: 'Home',
		redirect: '/dashboard',
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
	},
	{
		path: '/dashboard',
		name: 'Portal',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../muic/portal/mainportal.vue'),
	},
	// my muic : router
	{
		path: '/calendar',
		name: 'Calendar',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/calendar/mainevent.vue'),
	},
	{
		path: '/chatmessage',
		name: 'Chat assistant "Copter"',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		component: () => import('../muic/assischat/chatmessage.vue'),
	},
	{
		path: '/service',
		name: 'Service',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		component: () => import('../muic/service/service.vue'),
	},
	{
		path: '/service/form',
		name: 'Form create ticket',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		component: () => import('../muic/service/formticket.vue'),
	},
	{
		path: '/teaching',
		name: 'Teaching record',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/teaching/records.vue'),
	},
	{
		path: '/teaching/form',
		name: 'Teaching record submission form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/teaching/formrecord.vue'),
	},
	// vehicle
	{
		path: '/booking/vehicle',
		name: 'Vehicle',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/vehicle/main-vehicle.vue'),
	},
	{
		path: '/booking/vehicle/form',
		name: 'Vehicle submission form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/vehicle/formvehicle.vue'),
	},
	// photo booking
	{
		path: '/booking/pr/photo/form',
		name: 'Photo Booking Submission Form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/photo/form-photo.vue'),
	},
	{
		path: '/booking/pr/photo',
		name: 'Photo Booking',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/photo/main-photo.vue'),
	},
	// video booking
	{
		path: '/booking/pr/video/form',
		name: 'Video submission form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/video/form-video.vue'),
	},
	{
		path: '/booking/pr/video',
		name: 'Video booking',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/video/main-video.vue'),
	},
	// design booking
	{
		path: '/booking/pr/design/form',
		name: 'Design submission form',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/design/form-design.vue'),
	},
	{
		path: '/booking/pr/design',
		name: 'Design booking',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/design/main-design.vue'),
	},
	// design printing
	{
			path: '/booking/pr/printing/form',
			name: 'Printing submission form',
			layout: "dashboard",
			meta: {
				requiresAuth: true,
				permission: ['staff', 'faculty']
			},
			component: () => import('../muic/booking/prbooking/printing/form-printing.vue'),
	},
	{
			path: '/booking/pr/printing',
			name: 'Printing Booking',
			layout: "dashboard",
			meta: {
				requiresAuth: true,
				permission: ['staff', 'faculty']
			},
			component: () => import('../muic/booking/prbooking/printing/main-printing.vue'),
	},
	{
		path: '/tuitionpayment',
		name: 'Qr payment',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['student']
		},
		component: () => import('../muic/payment/mainpay.vue'),
	},
	{
		path: '/directory',
		name: 'Directory',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			// , 'student'
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/directory/search.vue'),
	},
	{
		path: '/accesslog',
		name: 'Campus access log',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		component: () => import('../muic/accesslog/listaccess.vue'),
	},
	{
		path: '/smartauthen',
		name: 'Smart authen log',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty', 'student']
		},
		component: () => import('../muic/accesslog/smartauthen.vue'),
	},
	{
		path: '/leaveofabsence',
		name: 'leave of absence',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/leaveofabsence/leave.vue'),
	},
	{
		path: '/studentactivity',
		name: 'Student Activity',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['student']
		},
		component: () => import('../muic/studentaffairs/mainactivity.vue'),
	},
	// {
	// 	path: '/studentgrade',
	// 	name: 'Student Grade',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: ['student']
	// 	},
	// 	component: () => import('../muic/studentgrade/maingrade.vue'),
	// },
	{
		path: '/hri',
		name: 'Human Resources',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/mainhri.vue'),
	},
	{
		path: '/hri/request',
		name: 'Human Resources Request',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/chooserequest.vue'),
	},
	{
		path: '/booking',
		name: 'Booking Systems',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/BookingList.vue'),
	},
	{
		path: '/booking/pr',
		name: 'Service by Media Development Section',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/booking/prbooking/PrBookingList.vue'),
	},
	{
		path: '/hri/request/flexible',
		name: 'Flexible',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_fixableday.vue'),
	},
	{
		path: '/hri/request/workfromhome',
		name: 'Work From Home',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_workforhome.vue'),
	},
	{
		path: '/hri/request/leaveofabsence',
		name: 'Leave of Absence',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_leave.vue'),
	},
	{
		path: '/hri/request/seminar',
		name: 'การขอไป อบรม / สัมมนา / ประชุม / ดูงาน',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_seminar.vue'),
	},
	{
		path: '/hri/request/otrequest',
		name: 'OT Management',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_ot.vue'),
	},
	{
		path: '/hri/request/absentTime',
		name: 'ลีมบันทึกเวลาเข้างาน',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_savetime.vue'),
	},
	{
		path: '/hri/request/travelAbroad',
		name: 'เดินทางไปต่างประเทศของบุคลากร',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/request/form_travel.vue'),
	},
	{
		path: '/profile-overview',
		name: 'profile-overview',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/hri/summaryprofile.vue'),
	},
	{
		path: '/document-app',
		name: 'IC APP',
		layout: "dashboard",
		meta: {
			requiresAuth: true,
			permission: ['staff', 'faculty']
		},
		component: () => import('../muic/documentapp/maindoc.vue'),
	},
	// {
	// 	path: '/parking',
	// 	name: 'Parking Fees',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: ['staff', 'faculty']
	// 	},
	// 	component: () => import('../muic/parking/mainparking.vue'),
	// },
	// {
	// 	path: '/coursetransfer',
	// 	name: 'Student Course Transfer',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: ['student']
	// 	},
	// 	component: () => import('../muic/studentcoursetransfer/transferrequest.vue'),
	// },
	// {
	// 	path: '/historyrequest',
	// 	name: 'University Exchange History',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: ['student']
	// 	},
	// 	component: () => import('../muic/studentcoursetransfer/historyrequest.vue'),
	// },
	// {
	// 	path: '/coursehistory',
	// 	name: 'Infomation of Course Exchange',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: ['student']
	// 	},
	// 	component: () => import('../muic/studentcoursetransfer/coursetransferlog.vue'),
	// },
	// {
	// 	path: '/gradehistory',
	// 	name: 'Grade Comparison',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: ['student']
	// 	},
	// 	component: () => import('../muic/studentcoursetransfer/gradecomparision.vue'),
	// },
	{
		path: '/Profile',
		name: 'Profile',
		layout: "dashboard",
		meta: {
			layoutClass: 'layout-profile',
			requiresAuth: true
		},
		component: () => import('../muic/profile/main.vue'),
	},
	// my muic : router 

	// maintance page Full-page
	{
		path: '/maintenancesys',
		name: 'maintenancesys',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/maintancepage/mainclosemy.vue'),
	},

	// device Full-page
	{
		path: '/support/welcome-t1-2023/',
		name: 'timescan',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/support/main.vue'),
	},
	{
		path: '/timescan',
		name: 'timescan',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/device/timescan.vue'),
	},
	{
		path: '/checkpoint',
		name: 'checkpoint',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/device/kioskapp.vue'),
	},
	{
		path: '/reset-device-app',
		name: 'reset-device-app',
		meta: {
			layoutClass: 'layout-sign-up',
			requiresAuth: true
		},
		component: () => import('../muic/documentapp/confirmuseapp.vue'),
	},
	{
		path: '/voteJob',
		name: 'voteJob',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/service/voteJob.vue'),
	},
	{
		path: '/eventcheckins',
		name: 'eventcheckins',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../muic/device/eventscan.vue'),
	},
	// device Full-page
	{
		path: '/layout',
		name: 'Layout',
		layout: "dashboard",
		meta: {
			requiresAuth: true
		},
		component: () => import('../views/Layout.vue'),
	},
	{
		path: '/fullchat',
		name: 'Layout',
		// layout: "dashboard",
		meta: {
			layoutClass: 'layout-sign-up',
			requiresAuth: true
		},
		component: () => import('../muic/assischat/fullchat.vue'),
	},
	// {
	// 	path: '/atk',
	// 	name: 'MUIC Pass',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true,
	// 		permission: ['staff', 'faculty', 'student']
	// 	},
	// 	component: () => import('../muic/muicpass/main_pass.vue'),
	// },
	// {
	// 	path: '/tables',
	// 	name: 'Tables',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true
	// 	},
	// 	component: () => import('../views/Tables.vue'),
	// },
	// {
	// 	path: '/billing',
	// 	name: 'Billing',
	// 	layout: "dashboard",
	// 	meta: {
	// 		requiresAuth: true
	// 	},
	// 	component: () => import('../views/Billing.vue'),
	// },
	// {
	// 	path: '/rtl',
	// 	name: 'RTL',
	// 	layout: "dashboard-rtl",
	// 	meta: {
	// 		layoutClass: 'dashboard-rtl',
	// 		requiresAuth: true
	// 	},
	// 	component: () => import('../views/RTL.vue'),
	// },
	// {
	// 	path: '/sign-in',
	// 	name: 'Sign-In',
	// 	meta: {
	// 		// requiresAuth: true
	// 	},
	// 	component: () => import('../views/Sign-In.vue'),
	// },
	// {
	// 	path: '/sign-up',
	// 	name: 'Sign-Up',
	// 	meta: {
	// 		layoutClass: 'layout-sign-up',
	// 		// requiresAuth: true
	// 	},
	// 	component: () => import('../views/Sign-Up.vue'),
	// },
]

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
	route.meta = route.meta || {};
	route.meta.layout = route.layout || parentLayout;

	if (route.children) {
		route.children = route.children.map((childRoute) => addLayoutToRoute(childRoute, route.meta.layout));
	}
	return route;
}

routes = routes.map((route) => addLayoutToRoute(route));

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

const whoami = async () => {
	let textRole = 0
	// let arrdata = []
	try {
		const res = await Vue.axios.get('/whoami/')
		if (res.status === 200) {
			// console.log('who >>' , res.data.roles)
			for (let index = 0; index < res.data.roles.length; index++) {
				const element = res.data.roles[index];
				if(element === 'student'){
					textRole++
				}
			}
			return [res.data , textRole != 0 ? 'student' : 'staff'];
		}
		return false;
	}
	catch (error) {
		return false;
	}
}

// const whoamiProfile = async () => {
// 	try {
// 		const res = await Vue.axios.get('/staff/profile/me/')
// 		if (res.status === 200) {
// 			return res.data;
// 		}
// 		return false;
// 	}
// 	catch (error) {
// 		return false;
// 	}
// }

router.beforeEach(async (to, from, next) => {
	// console.log('route >>' ,to.matched[0])
	if (to.matched.some(record => record.meta.requiresAuth)) {
		const res = await whoami()
		// console.log('res[0] >>' , res[0])
		// console.log('res[1] >>' , res[1])
		if (router.app.$keycloak.authenticated) {
			vueXstore.dispatch('setRoleUser',
				{
					username: res[0].username,
					roles: res[0].roles,
					permissions: res[0].permissions,
					codeId: res[0].usercode,
					flexible: res[0].flexible,
					tel: res[0].tel,
				}
			)
			// staff Only
			if([
				'/calendar','/document-app','/directory','/hri','/teaching','/teaching','/booking','/profile-overview','/leaveofabsence',
				'/teaching/form','/booking/vehicle/form','/booking/pr/photo/form','/booking/pr/photo','/booking/pr/video/form','/booking/pr/video',
				'/hri/request/leaveofabsence','/hri/request/travelAbroad','/hri/request','/hri/request/absentTime','/hri/request/seminar','/smartauthen',
			].includes(`${to.matched[0].path}`)){
				if(res[1] === 'staff'){
					next()
				}else{
					next('/')
				}
			}else{
				next()
			}				
		} else {
			const loginUrl = router.app.$keycloak.createLoginUrl()
			window.location.replace(loginUrl)
		}
	} else {
		next()
	}
})

export default router
